<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Desert King’s Pregnant Bride</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm01"><a id="page01"><div class="chapterHead"><h2 class="chapterTitle1"><span class="bold"><span>“You wanted to talk about ground rules.” Khalid’s voice was a rich drawl. “I agree. It’s well past time for that.”</span></span></h2></div><div class="chapterBody"><p class="paraNoIndent1"><span>The intensity of his stare held her taut and breathless as her heartbeat thudded, loud in her ears. Something had changed. Treacherous undercurrents swirled between them.</span></p><p class="paraNoIndent1"><span>“Perhaps we could work the details out tomorrow. It’s getting late.” Her words tumbled out in a rush. Maggie felt strangely vulnerable in this highly charged atmosphere.</span></p><p class="paraNoIndent1"><span>“There’s no need to wait until tomorrow,” he murmured.</span></p><p class="paraNoIndent1"><span>“There isn’t?” Maggie watched him stride around the desk, each movement slow and purposeful. She found herself turning so her back was to the desk and Khalid stood between her and the door. Tremors of shock vibrated through her. And something else. A tiny thrill of excitement. She must be mad!</span></p><p class="paraNoIndent1"><span>“No,” he said, his voice a deep rumble. “We’ll sort this out tonight.”</span></p><p class="paraNoIndent1"><span>Her eyes were a lustrous gold in the lamplight, shot with emerald fire. Khalid had never known any like them. Her chest rose and fell rapidly, her breasts thrusting in wanton invitation against the fabric. Her lips parted as her breaths shortened.</span></p><p class="paraNoIndent1"><span>His body tensed to the point of pain as he prolonged the suspense of anticipation a moment more. He’d never been one to rush his pleasure.</span></p><p class="paraNoIndent1"><span>And Maggie would be pure pleasure.</span></p></div></a></div>
<a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// desertkingspregnantbridethe_fm01.vue?6276fd3f